<template>
  <main>
    <Banner :info="bannerInfo" />
    <Dub />
    <Adapter title="DUB Series" :adatpersInfo="dubSeries" />
    <Adapter title="M Series" :adatpersInfo="mSeries" />
    <div id="videos">
      <Video v-for="(info, i) in videosInfo" :info="info" :key="i" />
    </div>
  </main>
</template>

<script>
import Banner from "@/components/Banner";
import Dub from "./_patentdub.vue";
import Adapter from "./adapter";
import Video from "./_video.vue";
import dubSeries from "./adapter/_dub_series";
import mSeries from "./adapter/_m_series copy";

export default {
  components: { Banner, Dub, Video, Adapter },
  data() {
    return {
      dubSeries,
      mSeries,
      bannerInfo: {
        src: require("@/assets/images/dub/banner.jpg"),
        alt: "patent dub",
      },
      videosInfo: [
        {
          title: "DUB SERIES INSTALLATION VIDEOS",
          videos: [
            {
              type: "install",
              brand: "bg",
              title: "Hook Type (9*3/B1)",
              ytId: "wBR7yqMsvS0",
            },
            {
              type: "install",
              brand: "bg",
              title: "Top Lock Arm (TL-2 adapter)",
              ytId: "gbmRE697kRs",
            },
            {
              type: "install",
              brand: "bg",
              title: "Top Lock Arm (TL-4 adapter)",
              ytId: "m1md_gajqh8",
            },
            {
              type: "install",
              brand: "bg",
              title: "Pinch Tab Arm (PT-3 adapter)",
              ytId: "omOJcmBAkiU",
            },
            {
              type: "install",
              brand: "bg",
              title: "Side Pin Arm (PH-2 adapter)",
              ytId: "ZPDlEZKOy70",
            },
            {
              type: "install",
              brand: "bg",
              title: "Top Lock Arm (M5-TLC adapter)",
              ytId: "ZcI-ZpfoRGI",
            },
            {
              type: "install",
              brand: "bg",
              title: "Pinch Tab Arm (PT-6 adapter)",
              ytId: "dndWWB6wjbw",
            },
            {
              type: "install",
              brand: "bg",
              title: "Bayonet Lock Arm (BL-2 adapter)",
              ytId: "rmghv1p_Sp4",
            },
            {
              type: "install",
              brand: "bg",
              title: "Central Lock Arm (CL adapter)",
              ytId: "n8bCJ-zdNh8",
            },
            {
              type: "install",
              brand: "bg",
              title: "Mercedes Lock Arm (ML adapter)",
              ytId: "KeIGn6pvz-w",
            },
            {
              type: "install",
              brand: "bg",
              title: "Pinch Lock Arm (PL adapter)",
              ytId: "LoFaLbj703k",
            },
          ],
        },
        {
          title: "DUB SERIES INSTALLATION VIDEOS【Multi-funtion adapter】",
          videos: [
            {
              type: "install",
              brand: "vg",
              title: 'Top Lock Arm "2" (4 in 1 Multi-function adapter)',
              ytId: "s8DWeZtjZoc",
            },
            {
              type: "install",
              brand: "vg",
              title: 'Top Lock Arm "4" (4 in 1 Multi-function adapter)',
              ytId: "IWCwaRlP-iM",
            },
            {
              type: "install",
              brand: "vg",
              title: "Pinch Tab Arm (4 in 1 Multi-function adapter)",
              ytId: "Nvv1oUKSUj8",
            },
            {
              type: "install",
              brand: "vg",
              title: "Side Pin Arm (4 in 1 Multi-function adapter)",
              ytId: "t-OHlFFTtEE",
            },
            {
              type: "install",
              brand: "vg",
              title: "Pinch Tab Arm (2 in 1 Multi-function adapter)",
              ytId: "2ak5fRML4HU",
            },
            {
              type: "install",
              brand: "vg",
              title: "Bayonet Lock Arm (2 in 1 Multi-function adapter)",
              ytId: "8pC_rPDaX3E",
            },
          ],
        },
      ],
    };
  },
};
</script>